import SERVICES_ACCESS_VK_ADS_API from 'api/services/accesses/vk-ads/v1'
import SERVICES_ACCESS_VK_API from 'api/services/accesses/vk/v1'
import SERVICES_ACCESS_YD_API_V2 from 'api/services/accesses/yd/v2'
import omit from 'lodash/omit'
import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import { call, debounce, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import {
  ACCESS_CREATE,
  ACCESS_DELETE,
  ACCESS_FETCH,
  ACCESS_FOR_PASSPORT_ORGANIZATION_CREATE,
  ACCESS_QUERY_TYPE,
  ACCESS_REMOVE_FROM_LIST,
  ACCESS_SET_FILTER,
  ACCESS_SET_LOADING,
  ACCESS_SET_PROCESSING_IDS,
  ACCESSES_SET_LIST,
} from 'modules/Services/types'

const API_BY_NETWORK_TYPE = {
  vk: SERVICES_ACCESS_VK_API,
  'vk-ads': SERVICES_ACCESS_VK_ADS_API,
}

function* getList({ payload }) {
  const { networkType } = payload

  try {
    yield put({
      type: ACCESS_SET_LOADING,
      payload: { loading: true },
    })

    const { response, error } = yield call(
      API_BY_NETWORK_TYPE[networkType].getAccountAccesses,
      payload,
    )

    if (error) {
      throw error
    }

    const { data } = response

    yield put({
      type: ACCESSES_SET_LIST,
      payload: {
        data,
      },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: ACCESS_SET_LOADING,
      payload: { loading: false },
    })
  }
}

function* accessDelete({ payload, meta: { resolve = () => {}, reject = () => {} } = {} }) {
  const { networkType } = payload

  yield put({
    type: ACCESS_SET_PROCESSING_IDS,
    payload: [payload.accessId],
  })

  try {
    const { response, error } = yield call(
      API_BY_NETWORK_TYPE[networkType].deleteAccountAccess,
      payload,
    )

    if (error) {
      throw error
    }

    yield put({
      type: ACCESS_REMOVE_FROM_LIST,
      payload: [payload.accessId],
    })

    resolve(response)
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.remove_failed',
      }),
    )
    reject(error)
    console.logXHR(error)
  } finally {
    yield put({
      type: ACCESS_SET_PROCESSING_IDS,
      payload: [],
    })
  }
}

function* typeQuery({ payload }) {
  yield put({ type: ACCESS_SET_FILTER, payload })
}

function* accessCreate({
  payload,
  formName,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  const { networkType, accessId } = payload

  try {
    yield put(startSubmit(formName))

    const apiCall = accessId
      ? API_BY_NETWORK_TYPE[networkType].updateAccountAccess
      : API_BY_NETWORK_TYPE[networkType].accountAccessCreate

    const { error } = yield call(apiCall, omit(payload, ['formName']))

    if (error) {
      throw error
    }

    yield put(stopSubmit(formName))

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_add',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors, 'form_errors::fields.')

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  }
}

function* accessForPassportOrganizationCreate({
  payload,
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  const { formName, ...rest } = payload

  try {
    yield put(startSubmit(formName))
    const { error } = yield call(SERVICES_ACCESS_YD_API_V2.accountAccessCreate, rest)

    if (error) {
      throw error
    }

    yield put(stopSubmit(formName))
    yield put(
      notificationShow({
        type: 'success',
        message:
          'services::forms.account_access_create.yd.notifications.invitation_successfully_sent',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors, 'form_errors::fields.')

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(ACCESS_FETCH, getList)
  yield takeLatest(ACCESS_DELETE, accessDelete)
  yield takeLatest(ACCESS_CREATE, accessCreate)
  yield takeLatest(ACCESS_FOR_PASSPORT_ORGANIZATION_CREATE, accessForPassportOrganizationCreate)
  yield debounce(500, ACCESS_QUERY_TYPE, typeQuery)
}
